import { render, staticRenderFns } from "./CommanfindingsSettings.vue?vue&type=template&id=5025c820&scoped=true&"
import script from "./CommanfindingsSettings.vue?vue&type=script&lang=js&"
export * from "./CommanfindingsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CommanfindingsSettings.vue?vue&type=style&index=0&id=5025c820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025c820",
  null
  
)

export default component.exports